var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKandasearchLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Drawing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("defs", {
    transform: "translate(-22 -81) translate(-20.9455 0) translate(0 2.36262)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -42.94553,
    y: -78.63738,
    height: 595.28,
    width: 841.89
  }))), /*#__PURE__*/React.createElement("clipPath", {
    transform: "translate(-22 -81) translate(-20.9455 0) translate(0 2.36262)",
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    d: "m-42.94553,-78.63738l841.89,0l0,595.28l-841.89,0l0,-595.28z"
  })), /*#__PURE__*/React.createElement("defs", {
    transform: "translate(-15.9455 0) translate(0 102.363)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15.94553,
    y: 102.36262,
    height: 595.28,
    width: 841.89
  }))), /*#__PURE__*/React.createElement("clipPath", {
    transform: "translate(-15.9455 0) translate(0 102.363)",
    id: "svg_5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    d: "m-15.94553,102.36262l841.89,0l0,595.28l-841.89,0l0,-595.28z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_6"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_9",
    fill: "rgb(41,113,86)",
    d: "m79.10441,17.60883c-32.82932,3.60216 -58.27611,26.64327 -63.58389,54.77832l29.50973,0c6.55772,-22.76617 26.12395,-40.42313 50.91905,-43.14194c23.1964,-2.5457 44.75337,8.67065 56.7156,27.15496c-11.5702,-25.80319 -41.09265,-42.35023 -73.56048,-38.79134z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_10",
    fill: "rgb(229,156,46)",
    d: "m100.9465,32.36624c20.97146,9.73984 35.51757,30.9735 35.51757,55.6184c0,33.85523 -27.44517,61.3004 -61.30295,61.3004c-23.89392,0 -44.58026,-13.68058 -54.69686,-33.62612c8.9023,27.27461 37.101,47.21251 70.53619,47.21251c40.58097,0 73.47902,-29.35444 73.47902,-65.55681c0,-33.19844 -27.66155,-60.61561 -63.53298,-64.94839z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_11",
    fill: "rgb(206,43,47)",
    d: "m80.40526,139.98816c27.65646,-3.02938 49.0836,-22.43523 53.55893,-46.13313l-24.86128,0c-5.51653,19.17419 -21.99483,34.04107 -42.88228,36.33474c-19.53568,2.14348 -37.68905,-7.30361 -47.77002,-22.87055c9.75002,21.73262 34.61385,35.67032 61.95464,32.66894z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_12",
    fill: "rgb(0,100,170)",
    d: "m54.21513,124.55614c-19.98373,-2.1893 -35.46157,-16.211 -38.69206,-33.33082l17.95481,0c3.98402,13.85369 15.90043,24.59653 30.98369,26.25123c14.1108,1.55033 27.23387,-5.27723 34.51457,-16.52158c-7.04904,15.69932 -25.00639,25.7701 -44.761,23.60116z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKandasearchLogo);
export default __webpack_public_path__ + "static/media/kandasearch-logo.b0c4511d2354a6174593ea0ac471f538.svg";
export { ForwardRef as ReactComponent };